import { setShareInfo, share as openShare } from 'kwsdk'

export function setShare(config, miniData) {
  // 分享参数透传，详见https://note.youdao.com/ynoteshare1/index.html?id=5642808b53f6e532cc622ca932662818&type=note
  const shareObj = {
    title: '孕产·亲子',
    desc: '孩子王孕产亲子平台，为您优选品质服务',
    link: location.href,
    ...config
  }
  // 微信小程序分享设置
  const shareInfo = {
    ...shareObj,
    userName: shareObj.userName /* || 'gh_362b01c44275' */, //传userName时，微信分享会使用小程序，不传默认链接分享
    webpageUrl: shareObj.link,
    path:
      shareObj.path ||
      `pages/mall-index/index?refererH5=${encodeURIComponent(shareObj.link)}`,
    mpTitle: shareObj.title,
    mpDescription: shareObj.desc,
    thumbUrl: shareObj.imgUrl,
    mpType: 0
  }
  try {
    console.log(shareInfo)
    setShareInfo({
      shareObj: shareInfo,
      /* 孩子王特卖小程序分享中转页分享参数，透传，默认带入shareObj中的title，thumbUrl或imgUrl， link, 
        参数文档https://code.haiziwang.com/frontend-document/projects-document/blob/master/wx-mp/mp-share-middle-for-h5.md */
      isMinPage: true,
      minShare: {
        ...miniData
      },
      wxName: 'mall'
    })
  } catch (e) {
    console.log(e)
  }
}

/* 拉起分享面板 */
export function openShareBoard() {
  openShare()
}
